import { render, staticRenderFns } from "./MsgModal.vue?vue&type=template&id=0f6ca1a3&scoped=true&"
import script from "./MsgModal.vue?vue&type=script&lang=js&"
export * from "./MsgModal.vue?vue&type=script&lang=js&"
import style0 from "./MsgModal.vue?vue&type=style&index=0&id=0f6ca1a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ca1a3",
  null
  
)

export default component.exports